import Hero from "./components/Hero";
import WorkflowSection from "./components/WorkflowSection";
import FeatureGrid from "./components/FeatureGrid";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import ToolsSection from "../../components/feature/ToolsSection";

export default function ProcessPage() {
  return (
     <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <div className="bg-[#0a0a0a] min-h-screen text-white">
          {/* Background Grid Pattern */}
          <div className="fixed inset-0 opacity-10 pointer-events-none">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage: `linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            ></div>
          </div>

          {/* Glowing Orbs */}
          <div className="fixed top-20 left-10 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl pointer-events-none"></div>
          <div className="fixed bottom-20 right-10 w-96 h-96 bg-red-500/10 rounded-full blur-3xl pointer-events-none"></div>

          <Hero />
          <WorkflowSection />
          <FeatureGrid />
          <ToolsSection />
        </div>
      </main>
      <Footer />
    </div>
  );
}
